import React from 'react';

interface TTSPlaybackIndicatorProps {
  isLoading: boolean;
  isPlaying: boolean;
  error?: boolean;
}

const TTSPlaybackIndicator: React.FC<TTSPlaybackIndicatorProps> = ({ isLoading, isPlaying, error }) => {
  if (error) {
    return (
      <div className="flex items-center justify-center gap-2 text-amber-400">
        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M12 3l9.66 16.5H2.34L12 3z" />
        </svg>
        <span className="text-sm">Audio unavailable — keep going!</span>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center gap-3 text-gray-400">
        <div className="animate-spin h-5 w-5 border-2 border-indigo-400 border-t-transparent rounded-full"></div>
        <span className="text-sm">Loading audio...</span>
      </div>
    );
  }

  if (isPlaying) {
    return (
      <div className="flex items-center justify-center gap-2 text-indigo-400">
        <div className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        <span className="ml-2 text-sm">Listen carefully...</span>
      </div>
    );
  }

  return null;
};

export default TTSPlaybackIndicator;
